
export enum DeclarationType {
  ASYLUM = 'Asylum',
  HARDSHIP_42B = 'Hardship - 42b',
  HARDSHIP_I601A = 'Hardship - I-601a Waiver',
  MOTION_REOPEN = 'Hardship - Motion to Reopen',
  MOTION_VACATE = 'Motion to Vacate',
  SIJS = 'SIJS Declaration'
}

export enum ProcessStatus {
  PENDING = 'Pending Appointment',
  IN_PROGRESS = 'Questioning In Progress',
  PAUSED = 'Paused',
  COMPLETED = 'Questioning Completed',
  DRAFTED = 'Draft Declaration Ready'
}

export enum StaffRole {
  SUPER_ADMIN = 'Super Admin',
  ADMIN = 'Admin',
  SENIOR_PARALEGAL = 'Senior Paralegal',
  PARALEGAL = 'Paralegal'
}

export enum TwilioCallStatus {
  IDLE = 'idle',
  DIALING = 'dialing',
  CONNECTED = 'connected',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

export interface StaffUser {
  id: string;
  name: string;
  email: string;
  role: StaffRole;
  password?: string;
  mustChangePassword?: boolean;
  createdAt: string;
}

export interface Client {
  id: string;
  name: string;
  phone: string;
  email: string;
  language: string;
  focusDetails: string;
}

export interface Appointment {
  dateTime: string;
  method: 'Telephonic' | 'Text';
}

export interface NotificationStatus {
  reminder24hSent: boolean;
  reminder15mSent: boolean;
  rescheduleSent?: boolean;
  transcriptEmailSent?: boolean;
}

export interface TranscriptEntry {
  role: 'AI' | 'Client';
  text: string;
  timestamp: string;
}

export interface FactProcess {
  id: string;
  type: DeclarationType;
  client: Client;
  appointment: Appointment;
  status: ProcessStatus;
  notifications: NotificationStatus;
  transcript: TranscriptEntry[];
  draftedDeclaration?: string;
  createdAt: string;
  lastUpdated: string;
  assignedStaffId?: string;
}

export interface GeminiLiveSession {
  sessionId: string;
  status: 'connecting' | 'active' | 'closed';
  startTime: string;
}
